import React from "react";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Header from "../../component/common/Header";

import Loader from "../../component/common/Loader";
import ModalWindow from "../../component/common/ModalWindow";
import AddHotelAllowance from "./../../component/reimbursement/HotelAllowance";
import AddRoadMilage from "./../../component/reimbursement/RoadMilage";
import AddTravelDetail from "./../../component/reimbursement/TravelFare";
import UploadBill from "./../../component/reimbursement/UploadBill";

import {
  addReimbursement,
  getEtourDetail,
  uploadBill,
} from "../../actions/EtourAction";
import CONSTANT from "../../constant";
import {
  getDateParts,
  getStorage,
  getTimeParts,
  onChange,
  validateForm,
} from "../../utils";

class ComponentName extends React.Component<any, any> {
  eTourData: any;
  clrInterval: any;
  constructor(props: any) {
    super(props);
    const recipients = getStorage(CONSTANT.cookie.recipients);
    this.state = {
      code: props.match.params.code,
      programmeDetail: undefined,

      advance: { name: "advance", value: "", error: "", isRequired: true },
    
      travelFare: {
        name: "travelFare",
        value: [],
        error: "",
        isRequired: true,
      },
      roadMilage: {
        name: "roadMilage",
        value: [],
        options: recipients,
        error: "",
        isRequired: false,
      },
      hotelAllowance: {
        name: "hotelAllowance",
        value: [],
        error: "",
        isRequired: false,
      },
      cashAllowance: {
        name: "cashAllowance",
        value: [],
        error: "",
        isRequired: false,
      },
      travelFareBills: {
        name: "travelFareBills",
        value: [],
        error: "",
        isRequired: false,
      },
      roadMilageBills: {
        name: "roadMilageBills",
        value: [],
        error: "",
        isRequired: false,
      },
      hotelAllowanceBills: {
        name: "hotelAllowanceBills",
        value: [],
        error: "",
        isRequired: false,
      },
      cashAllowanceBills: {
        name: "cashAllowanceBills",
        value: [],
        error: "",
        isRequired: false,
      },

      showLoader: false,
      showFileModal: false,
      modelType: undefined,

      showTravelFareModal: false,
      showRoadMilageModal: false,
      showHotelAllowanceModal: false,
      showCashAllowanceModal: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.etour;
    const { code } = this.state;
    getEtourDetail(code).then((res: any) => {
      if (res.error) {
        alert(res.error);
      } else {
        this.setState({ programmeDetail: res.result.programmeDetail });
      }
    });

    const json: any = localStorage.getItem(
      `eTourDraft-${this.props.match.params.code}`
    );
    this.eTourData = JSON.parse(json);

    if (this.eTourData) {
      this.setState({
        travelFare: {
          ...this.state.travelFare,
          value: this.eTourData.model.travelFare,
        },
        roadMilage: {
          ...this.state.roadMilage,
          value: this.eTourData.model.roadMilage,
        },
        hotelAllowance: {
          ...this.state.hotelAllowance,
          value: this.eTourData.model.hotelAllowance,
        },
        cashAllowance: {
          ...this.state.cashAllowance,
          value: this.eTourData.model.cashAllowance,
        },
      });
    }

    this.clrInterval = setInterval(this.saveDraft, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.clrInterval);
  }

  render() {
    const { code, showLoader } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2 px-0">
            <Header />
          </div>
          <div className="col-md-10">
            <div className="row my-3">
              <div className="col-md-8">
                <h1 className="page-title">Reimbursement Detail </h1>
              </div>
              <div className="col-md-4">
                <Link
                  className="btn btn-sm btn-link float-right"
                  to={CONSTANT.component.userETourDetail.url.replace(
                    ":code",
                    code
                  )}
                >
                  Go Back
                </Link>
              </div>
            </div>

            {this.renderTravelFare()}
            {this.renderRoadMilage()}
            {this.renderHotelAllowance()}
            {this.renderCashAllowance()}
            {this.renderCashDetail()}

            <div className="row my-5">
              <div className="col-md-3">
                <Link
                  to={CONSTANT.component.userETourDetail.url.replace(
                    ":code",
                    code
                  )}
                  className="btn btn-block cancel-button btn-sm btn-sm"
                >
                  Cancel
                </Link>
              </div>
              <div className="col-md-6">&nbsp;</div>
              <div className="col-md-3">
                <button
                  type="button"
                  onClick={this.onSubmit}
                  className="btn btn-block submit-button btn-sm"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        {showLoader && <Loader />}
      </div>
    );
  }

  renderCashDetail = () => {
    const { advance} = this.state;
    const { travelFare, roadMilage, hotelAllowance, cashAllowance } =
      this.state;
    let tfTotal = travelFare.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    let rmTotal = roadMilage.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    let haTotal = hotelAllowance.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    let caTotal = cashAllowance.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    const calculatedTotal = tfTotal + rmTotal + haTotal + caTotal;
    const calculatedBalance = parseFloat(advance.value) - calculatedTotal;
    return (
      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>
                      Advance taken<small>*</small>
                    </label>
                    <NumberFormat
                      prefix={`${CONSTANT.static.currencySymbol} `}
                      decimalScale={2}
                      thousandSeparator={true}
                      allowNegative={false}
                      className={
                        advance.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={advance.name}
                      value={advance.value}
                      onValueChange={(e: any) => {
                        this.onChange({
                          target: { name: advance.name, value: e.value },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>
                      Amount used <small>*</small>
                    </label>
                    <NumberFormat
                      prefix={`${CONSTANT.static.currencySymbol} `}
                      decimalScale={2}
                      thousandSeparator={true}
                      allowNegative={false}
                      disabled={true}
                      className="form-control"
                      placeholder=""
                      value={calculatedTotal}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>
                      Balance <small>*</small>
                    </label>
                    <NumberFormat
                      prefix={`${CONSTANT.static.currencySymbol} `}
                      decimalScale={2}
                      thousandSeparator={true}
                      disabled={true}
                      className="form-control"
                      placeholder=""
                      value={calculatedBalance}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // travel fare section
  renderTravelFare = () => {
    const {
      showTravelFareModal,
      travelFare,
      programmeDetail,
      travelFareBills,
      showFileModal,
    } = this.state;
    const locations: any = [];

    programmeDetail &&
      programmeDetail.forEach((item: any) => {
        locations.push(item.from);
        locations.push(item.to);
      });

    let totalAmout = travelFare.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="float-left">Travel Fare</div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={() => this.openFileUploader("travelFare")}
                  className="btn btn-link btn-sm"
                >
                  Upload Bill(s)
                </button>
              </div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={this.onAddTavelFare}
                  className="btn btn-link btn-sm"
                >
                  Add an item
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <table
                    className={
                      travelFare.error.length > 0
                        ? "table table-bordered table-hover table-danger"
                        : "table table-bordered table-hover"
                    }
                  >
                    <tbody>
                      <tr className="active">
                        <th
                          rowSpan={2}
                          className="align-bottom"
                          style={{ width: "3%" }}
                        >
                          #
                        </th>
                        <th colSpan={2} className="text-center ">
                          Departure
                        </th>
                        <th colSpan={2} className="text-center">
                          Arrival
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Mode of Journey
                        </th>
                        <th colSpan={2} className="text-center">
                          Fare
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Amount
                        </th>
                        <th rowSpan={2} style={{ width: "3%" }}></th>
                      </tr>
                      <tr>
                        <th>Station</th>
                        <th>Date & Hour</th>
                        <th>Station</th>
                        <th>Date & Hour</th>
                        <th>Class</th>
                        <th>No. of Fare</th>
                      </tr>
                      {travelFare.value.length === 0 && (
                        <tr>
                          <td colSpan={11} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                      {travelFare.value.map((item: any, index: number) => {
                        const depDt = getDateParts(item.depDate);
                        const depTm = getTimeParts(item.depTime);
                        const arrDt = getDateParts(item.arrDate);
                        const arrTm = getTimeParts(item.arrTime);
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.depStation}</td>
                            <td>
                              {`${depDt.date} ${depDt.monthName} ${depDt.year}`}{" "}
                              {`${depTm.hour}:${depTm.minute} ${depTm.amOrpm}`}
                            </td>
                            <td>{item.arrStation}</td>
                            <td>
                              {`${arrDt.date} ${arrDt.monthName} ${arrDt.year}`}{" "}
                              {`${arrTm.hour}:${arrTm.minute} ${arrTm.amOrpm}`}
                            </td>
                            <td>{item.modeOfJourney}</td>
                            <td>{item.fareClass}</td>
                            <td>{item.noOfFare}</td>
                            <td>
                              {CONSTANT.static.currencySymbol}{" "}
                              {parseFloat(item.amount).toLocaleString(
                                CONSTANT.static.locale
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link text-danger"
                                onClick={() =>
                                  this.onDeleteTravelFare(item.id, item.amount)
                                }
                                data-id={item.id}
                              >
                                <i
                                  className="fa fa-trash-o pe-none"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={8}>Total</td>
                        <td colSpan={2} className="font-weight-bold">
                          {CONSTANT.static.currencySymbol}{" "}
                          {parseFloat(totalAmout).toLocaleString(
                            CONSTANT.static.locale
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div>
                <div className="float-left">Bill(s)</div>
              </div>
              <div className="row">
                <div className="col">
                  {Array.from(travelFareBills.value).map(function (
                    item: any,
                    index: number
                  ) {
                    return (
                      <span key={index} className="badge badge-primary mr-1">
                        {item.name}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showTravelFareModal && (
          <ModalWindow
            title="Travel Detail"
            backdrop={false}
            toggleModal={this.onCancelTavelFare}
          >
            <AddTravelDetail
              loc={locations}
              onSubmit={this.onSubmitTravelFare}
              onCancel={this.onCancelTavelFare}
            />
          </ModalWindow>
        )}
        {showFileModal && (
          <ModalWindow
            title="Upload Bill(s)"
            backdrop={false}
            toggleModal={this.onCancelFileUploader}
          >
            <UploadBill
              onSubmit={this.onSubmitFileUploader}
              onCancel={this.onCancelFileUploader}
            />
          </ModalWindow>
        )}
      </div>
    );
  };

  onAddTavelFare = () => {
    this.setState({ showTravelFareModal: true });
  };

  openFileUploader = (name: any) => {
    this.setState({ showFileModal: true, modelType: name });
  };

  onCancelTavelFare = () => {
    this.setState({ showTravelFareModal: false });
  };

  onCancelFileUploader = () => {
    this.setState({ showFileModal: false, modelType: undefined });
  };

  onSubmitFileUploader = (model: any) => {
    if (this.state.modelType === "travelFare") {
      onChange(this, this.state.travelFareBills.name, [
        ...this.state.travelFareBills.value,
        ...model,
      ]);
    } else if (this.state.modelType === "roadMilage") {
      onChange(this, this.state.roadMilageBills.name, [
        ...this.state.roadMilageBills.value,
        ...model,
      ]);
    } else if (this.state.modelType === "hotelAllowance") {
      onChange(this, this.state.hotelAllowanceBills.name, [
        ...this.state.hotelAllowanceBills.value,
        ...model,
      ]);
    } else if (this.state.modelType === "cashAllowance") {
      onChange(this, this.state.cashAllowanceBills.name, [
        ...this.state.cashAllowanceBills.value,
        ...model,
      ]);
    }
    this.onCancelFileUploader();
  };

  onSubmitTravelFare = (model: any) => {
    onChange(this, this.state.travelFare.name, [
      ...this.state.travelFare.value,
      model,
    ]);
    this.onCancelTavelFare();
  };

  onDeleteTravelFare = (id: any, amount: any) => {
    // const id = parseInt(e.target.dataset.id, 10);
    const isSure = window.confirm(
      "Are you sure, you want to delete this record?"
    );
    if (isSure) {
      const traveFare = this.state.travelFare.value.filter(
        (i: any) => i.id !== id
      );
      onChange(this, this.state.travelFare.name, traveFare);
      const json: any = localStorage.getItem(
        `eTourDraft-${this.props.match.params.code}`
      );
      const eTourData = JSON.parse(json);
      eTourData.model.travelFare = eTourData.model.travelFare.filter(
        (i: any) => i.id !== id
      );
      eTourData.model.balanceDetail = eTourData.model.balanceDetail - amount;
      localStorage.setItem(
        `eTourDraft-${this.props.match.params.code}`,
        JSON.stringify(eTourData)
      );
    }
  };
  // travel fare section

  // road milage section
  renderRoadMilage = () => {
    const { roadMilage, showRoadMilageModal, roadMilageBills } = this.state;
    let totalAmout = roadMilage.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    return (
      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="float-left">
                Road Milage(for hired-owned conveyance)
              </div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={() => this.openFileUploader("roadMilage")}
                  className="btn btn-link btn-sm"
                >
                  Upload Bill(s)
                </button>
              </div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={this.onAddRoadMilage}
                  className="btn btn-link btn-sm"
                >
                  Add an item
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <table
                    className={
                      roadMilage.error.length > 0
                        ? "table table-bordered table-hover table-danger"
                        : "table table-bordered table-hover"
                    }
                  >
                    <tbody>
                      <tr className="active">
                        <th
                          rowSpan={2}
                          className="align-bottom"
                          style={{ width: "3%" }}
                        >
                          #
                        </th>
                        <th colSpan={2} className="text-center">
                          From
                        </th>
                        <th colSpan={2} className="text-center">
                          To
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Mode of Conveyance
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Total K.M.
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Rate
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Vehicle No.
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Amount
                        </th>
                        <th rowSpan={2} style={{ width: "3%" }}></th>
                      </tr>
                      <tr>
                        <th>Place</th>
                        <th>Date & Hour</th>
                        <th>Place</th>
                        <th>Date & Hour</th>
                      </tr>
                      {roadMilage.value.length === 0 && (
                        <tr>
                          <td colSpan={12} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                      {roadMilage.value.map((item: any, index: number) => {
                        const depDt = getDateParts(item.depDate);
                        const depTm = getTimeParts(item.depTime);
                        const arrDt = getDateParts(item.arrDate);
                        const arrTm = getTimeParts(item.arrTime);

                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.depPlace}</td>
                            <td>
                              {`${depDt.date} ${depDt.monthName} ${depDt.year}`}{" "}
                              {`${depTm.hour}:${depTm.minute} ${depTm.amOrpm}`}
                            </td>
                            <td>{item.arrPlace}</td>
                            <td>
                              {`${arrDt.date} ${arrDt.monthName} ${arrDt.year}`}{" "}
                              {`${arrTm.hour}:${arrTm.minute} ${arrTm.amOrpm}`}
                            </td>
                            <td>{item.modeOfConveyance}</td>
                            <td>{item.totalKM}</td>
                            <td>{item.rate}</td>
                            <td>{item.vehicleNumber}</td>
                            <td>
                              {CONSTANT.static.currencySymbol}{" "}
                              {parseFloat(item.amount).toLocaleString(
                                CONSTANT.static.locale
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link text-danger"
                                onClick={() =>
                                  this.onDeleteRoadMilage(item.id, item.amount)
                                }
                                data-id={item.id}
                              >
                                <i
                                  className="fa fa-trash-o pe-none"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={9}>Total</td>
                        <td colSpan={2} className="font-weight-bold">
                          {CONSTANT.static.currencySymbol}{" "}
                          {parseFloat(totalAmout).toLocaleString(
                            CONSTANT.static.locale
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div>
                <div className="float-left"> Bill(s)</div>
              </div>
              <div className="row">
                <div className="col">
                  {Array.from(roadMilageBills.value).map(function (
                    item: any,
                    index: number
                  ) {
                    return (
                      <span key={index} className="badge badge-primary mr-1">
                        {item.name}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showRoadMilageModal && (
          <ModalWindow
            title="Road Milage Detail"
            backdrop={false}
            toggleModal={this.onCancelRoadMilage}
          >
            <AddRoadMilage
              onSubmit={this.onSubmitRoadMilage}
              onCancel={this.onCancelRoadMilage}
            />
          </ModalWindow>
        )}
      </div>
    );
  };

  onAddRoadMilage = () => {
    this.setState({ showRoadMilageModal: true });
  };

  onCancelRoadMilage = () => {
    this.setState({ showRoadMilageModal: false });
  };

  onSubmitRoadMilage = (model: any) => {
    onChange(this, this.state.roadMilage.name, [
      ...this.state.roadMilage.value,
      model,
    ]);
    this.onCancelRoadMilage();
  };

  onDeleteRoadMilage = (id: any, amount: any) => {
    // const id = parseInt(e.target.dataset.id, 10);
    const isSure = window.confirm(
      "Are you sure, you want to delete this record?"
    );
    if (isSure) {
      const roadMilage = this.state.roadMilage.value.filter(
        (i: any) => i.id !== id
      );
      onChange(this, this.state.roadMilage.name, roadMilage);
      const json: any = localStorage.getItem(
        `eTourDraft-${this.props.match.params.code}`
      );
      const roadMilageData = JSON.parse(json);
      roadMilageData.model.travelFare = roadMilageData.model.travelFare.filter(
        (i: any) => i.id !== id
      );
      roadMilageData.model.balanceDetail =
        roadMilageData.model.balanceDetail - amount;
      localStorage.setItem(
        `eTourDraft-${this.props.match.params.code}`,
        JSON.stringify(roadMilageData)
      );
    }
  };
  // road milage section

  // hotel allowance section
  renderHotelAllowance = () => {
    const { hotelAllowance, showHotelAllowanceModal, hotelAllowanceBills } =
      this.state;

    let totalAmout = hotelAllowance.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    return (
      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="float-left">Hotel/Loading Allowance</div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={() => this.openFileUploader("hotelAllowance")}
                  className="btn btn-link btn-sm"
                >
                  Upload Bill(s)
                </button>
              </div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={this.onAddHotelAllowance}
                  className="btn btn-link btn-sm"
                >
                  Add an item
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <table
                    className={
                      hotelAllowance.error.length > 0
                        ? "table table-bordered table-hover table-danger"
                        : "table table-bordered table-hover"
                    }
                  >
                    <tbody>
                      <tr className="active">
                        <th
                          rowSpan={2}
                          className="align-bottom"
                          style={{ width: "3%" }}
                        >
                          #
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Place of Stay
                        </th>
                        <th colSpan={2} className="text-center">
                          Duration of stay
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          No. of days
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          No. of D.A.
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Rate
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Amount
                        </th>
                        <th rowSpan={2} style={{ width: "3%" }}></th>
                      </tr>
                      <tr>
                        <th>From</th>
                        <th>To</th>
                      </tr>
                      {hotelAllowance.value.length === 0 && (
                        <tr>
                          <td colSpan={11} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                      {hotelAllowance.value.map((item: any, index: number) => {
                        const fdt = getDateParts(item.fromDate);
                        const tdt = getDateParts(item.toDate);
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.place}</td>
                            <td>{`${fdt.date} ${fdt.monthName} ${fdt.year}`}</td>
                            <td>{`${tdt.date} ${tdt.monthName} ${tdt.year}`}</td>
                            <td>{item.noOfDays}</td>
                            <td>{item.noOfDA}</td>
                            <td>{item.rate}</td>
                            <td>
                              {CONSTANT.static.currencySymbol}{" "}
                              {parseFloat(item.amount).toLocaleString(
                                CONSTANT.static.locale
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link text-danger"
                                onClick={() =>
                                  this.onDeleteHotelAllowance(
                                    item.id,
                                    item.amount
                                  )
                                }
                                data-id={item.id}
                              >
                                <i
                                  className="fa fa-trash-o pe-none"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={7}>Total</td>
                        <td colSpan={2} className="font-weight-bold">
                          {CONSTANT.static.currencySymbol}{" "}
                          {parseFloat(totalAmout).toLocaleString(
                            CONSTANT.static.locale
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div>
                <div className="float-left"> Bill(s)</div>
              </div>
              <div className="row">
                <div className="col">
                  {Array.from(hotelAllowanceBills.value).map(function (
                    item: any,
                    index: number
                  ) {
                    return (
                      <span key={index} className="badge badge-primary mr-1">
                        {item.name}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showHotelAllowanceModal && (
          <ModalWindow
            title="Hotel allowance Detail"
            backdrop={false}
            toggleModal={this.onCancelHotelAllowance}
          >
            <AddHotelAllowance
              onSubmit={this.onSubmitHotelAllowance}
              onCancel={this.onCancelHotelAllowance}
            />
          </ModalWindow>
        )}
      </div>
    );
  };

  onAddHotelAllowance = () => {
    this.setState({ showHotelAllowanceModal: true });
  };

  onCancelHotelAllowance = () => {
    this.setState({ showHotelAllowanceModal: false });
  };

  onSubmitHotelAllowance = (model: any) => {
    onChange(this, this.state.hotelAllowance.name, [
      ...this.state.hotelAllowance.value,
      model,
    ]);
    this.onCancelHotelAllowance();
  };

  onDeleteHotelAllowance = (id: any, amount: any) => {
    // const id = parseInt(e.target.dataset.id, 10);
    const isSure = window.confirm(
      "Are you sure, you want to delete this record?"
    );
    if (isSure) {
      const hotelAllowance = this.state.hotelAllowance.value.filter(
        (i: any) => i.id !== id
      );
      onChange(this, this.state.hotelAllowance.name, hotelAllowance);
      const json: any = localStorage.getItem(
        `eTourDraft-${this.props.match.params.code}`
      );
      const hotelAllowanceData = JSON.parse(json);
      hotelAllowanceData.model.travelFare =
        hotelAllowanceData.model.travelFare.filter((i: any) => i.id !== id);
      hotelAllowanceData.model.balanceDetail =
        hotelAllowanceData.model.balanceDetail - amount;
      localStorage.setItem(
        `eTourDraft-${this.props.match.params.code}`,
        JSON.stringify(hotelAllowanceData)
      );
    }
  };
  // hotel allowance section

  // cash allowance section
  renderCashAllowance = () => {
    const { cashAllowance, showCashAllowanceModal, cashAllowanceBills } =
      this.state;
    let totalAmout = cashAllowance.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    return (
      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="float-left">Cash Allowance</div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={() => this.openFileUploader("cashAllowance")}
                  className="btn btn-link btn-sm"
                >
                  Upload Bill(s)
                </button>
              </div>
              <div className="float-right">
                <button
                  type="button"
                  onClick={this.onAddCashAllowance}
                  className="btn btn-link btn-sm"
                >
                  Add an item
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <table
                    className={
                      cashAllowance.error.length > 0
                        ? "table table-bordered table-hover table-danger"
                        : "table table-bordered table-hover"
                    }
                  >
                    <tbody>
                      <tr className="active">
                        <th
                          rowSpan={2}
                          className="align-bottom"
                          style={{ width: "3%" }}
                        >
                          #
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Place of Stay
                        </th>
                        <th colSpan={2} className="text-center">
                          Duration of stay
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          No. of days
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          No. of D.A.
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Rate
                        </th>
                        <th rowSpan={2} className="text-center align-bottom">
                          Amount
                        </th>
                        <th rowSpan={2} style={{ width: "3%" }}></th>
                      </tr>
                      <tr>
                        <th>From</th>
                        <th>To</th>
                      </tr>
                      {cashAllowance.value.length === 0 && (
                        <tr>
                          <td colSpan={11} className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                      {cashAllowance.value.map((item: any, index: number) => {
                        const fdt = getDateParts(item.fromDate);
                        const tdt = getDateParts(item.toDate);
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.place}</td>
                            <td>{`${fdt.date} ${fdt.monthName} ${fdt.year}`}</td>
                            <td>{`${tdt.date} ${tdt.monthName} ${tdt.year}`}</td>
                            <td>{item.noOfDays}</td>
                            <td>{item.noOfDA}</td>
                            <td>{item.rate}</td>
                            <td>
                              {CONSTANT.static.currencySymbol}{" "}
                              {parseFloat(item.amount).toLocaleString(
                                CONSTANT.static.locale
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link text-danger"
                                onClick={() =>
                                  this.onDeleteCashAllowance(
                                    item.id,
                                    item.amount
                                  )
                                }
                                data-id={item.id}
                              >
                                <i
                                  className="fa fa-trash-o pe-none"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={7}>Total</td>
                        <td colSpan={2} className="font-weight-bold">
                          {CONSTANT.static.currencySymbol}{" "}
                          {parseFloat(totalAmout).toLocaleString(
                            CONSTANT.static.locale
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div>
                <div className="float-left"> Bill(s)</div>
              </div>
              <div className="row">
                <div className="col">
                  {Array.from(cashAllowanceBills.value).map(function (
                    item: any,
                    index: number
                  ) {
                    return (
                      <span key={index} className="badge badge-primary mr-1">
                        {item.name}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showCashAllowanceModal && (
          <ModalWindow
            title="Cash Allowance"
            backdrop={false}
            toggleModal={this.onCancelCashAllowance}
          >
            <AddHotelAllowance
              onSubmit={this.onSubmitCashAllowance}
              onCancel={this.onCancelCashAllowance}
            />
          </ModalWindow>
        )}
      </div>
    );
  };

  onAddCashAllowance = () => {
    this.setState({ showCashAllowanceModal: true });
  };

  onCancelCashAllowance = () => {
    this.setState({ showCashAllowanceModal: false });
  };

  onSubmitCashAllowance = (model: any) => {
    onChange(this, this.state.cashAllowance.name, [
      ...this.state.cashAllowance.value,
      model,
    ]);
    this.onCancelCashAllowance();
  };

  onDeleteCashAllowance = (id: any, amount: any) => {
    // const id = parseInt(e.target.dataset.id, 10);
    const isSure = window.confirm(
      "Are you sure, you want to delete this record?"
    );
    if (isSure) {
      const cashAllowance = this.state.cashAllowance.value.filter(
        (i: any) => i.id !== id
      );
      onChange(this, this.state.cashAllowance.name, cashAllowance);
      const json: any = localStorage.getItem(
        `eTourDraft-${this.props.match.params.code}`
      );
      const cashAllowanceData = JSON.parse(json);
      cashAllowanceData.model.travelFare =
        cashAllowanceData.model.travelFare.filter((i: any) => i.id !== id);
      cashAllowanceData.model.balanceDetail =
        cashAllowanceData.model.balanceDetail - amount;
      localStorage.setItem(
        `eTourDraft-${this.props.match.params.code}`,
        JSON.stringify(cashAllowanceData)
      );
    }
  };
  // cash allowance section

  onChange = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;

    onChange(this, name, value);
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm(this)) {
      this.setState({ showLoader: true });
      const st = this.state;

      const { travelFare, roadMilage, hotelAllowance, cashAllowance, advance } =
        this.state;
      let tfTotal = travelFare.value.reduce(function (
        accumulator: any,
        currentValue: any
      ) {
        return accumulator + parseFloat(currentValue.amount);
      },
      0);
      let rmTotal = roadMilage.value.reduce(function (
        accumulator: any,
        currentValue: any
      ) {
        return accumulator + parseFloat(currentValue.amount);
      },
      0);
      let haTotal = hotelAllowance.value.reduce(function (
        accumulator: any,
        currentValue: any
      ) {
        return accumulator + parseFloat(currentValue.amount);
      },
      0);
      let caTotal = cashAllowance.value.reduce(function (
        accumulator: any,
        currentValue: any
      ) {
        return accumulator + parseFloat(currentValue.amount);
      },
      0);
      const calculatedTotal = tfTotal + rmTotal + haTotal + caTotal;
      const calculatedBalance = parseFloat(advance.value) - calculatedTotal;

      const model = {
        eTourCode: st.code,
        balanceDetail: {
          advance: st.advance.value,
          used: calculatedTotal,
          balance: calculatedBalance,
        },
        travelFare: st.travelFare.value,
        roadMilage: st.roadMilage.value,
        hotelAllowance: st.hotelAllowance.value,
        cashAllowance: st.cashAllowance.value,
      };

      addReimbursement(model).then(async (res: any) => {
        if (res.status === CONSTANT.static.apiStatus.success) {
          for (let i = 0; i < st.travelFareBills.value.length; i++) {
            const uid = st.travelFareBills.value[i].uid;
            const bills = st.travelFareBills.value[i];
            const itemModel = {
              eTourCode: res.result.eTourCode,
              transactionUID: uid,
              attachment: bills,
              reimbursementType:
                CONSTANT.static.reimbursementTypeBills.travelFareBills,
            };
            await uploadBill(itemModel);
          }

          for (let i = 0; i < st.roadMilageBills.value.length; i++) {
            const uid = st.roadMilageBills.value[i].uid;
            const bills = st.roadMilageBills.value[i];
            const itemModel = {
              eTourCode: res.result.eTourCode,
              transactionUID: uid,
              attachment: bills,
              reimbursementType:
                CONSTANT.static.reimbursementTypeBills.roadMilageBills,
            };
            await uploadBill(itemModel);
          }

          for (let i = 0; i < st.hotelAllowanceBills.value.length; i++) {
            const uid = st.hotelAllowanceBills.value[i].uid;
            const bills = st.hotelAllowanceBills.value[i];
            const itemModel = {
              eTourCode: res.result.eTourCode,
              transactionUID: uid,
              attachment: bills,
              reimbursementType:
                CONSTANT.static.reimbursementTypeBills.hotelAllowanceBills,
            };
            await uploadBill(itemModel);
          }

          for (let i = 0; i < st.cashAllowanceBills.value.length; i++) {
            const uid = st.cashAllowanceBills.value[i].uid;
            const bills = st.cashAllowanceBills.value[i];
            const itemModel = {
              eTourCode: res.result.eTourCode,
              transactionUID: uid,
              attachment: bills,
              reimbursementType:
                CONSTANT.static.reimbursementTypeBills.cashAllowanceBills,
            };
            await uploadBill(itemModel);
          }

          this.props.history.push(
            CONSTANT.component.userETourDetail.url.replace(":code", st.code)
          );
        } else {
          alert(res.error);
        }
        this.setState({ showLoader: false });
      });
    }
  };

  saveDraft = () => {
    const st = this.state;

    const { travelFare, roadMilage, hotelAllowance, cashAllowance, advance } =
      this.state;
    let tfTotal = travelFare.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    let rmTotal = roadMilage.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    let haTotal = hotelAllowance.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    let caTotal = cashAllowance.value.reduce(function (
      accumulator: any,
      currentValue: any
    ) {
      return accumulator + parseFloat(currentValue.amount);
    },
    0);
    const calculatedTotal = tfTotal + rmTotal + haTotal + caTotal;
    const calculatedBalance = parseFloat(advance.value) - calculatedTotal;

    const model = {
      eTourCode: st.code,
      balanceDetail: {
        advance: st.advance.value,
        used: calculatedTotal,
        balance: calculatedBalance,
      },
      travelFare: st.travelFare.value,
      roadMilage: st.roadMilage.value,
      hotelAllowance: st.hotelAllowance.value,
      cashAllowance: st.cashAllowance.value,
    };

    if (
      model.travelFare.length > 0 ||
      model.roadMilage.length > 0 ||
      model.hotelAllowance.length > 0 ||
      model.cashAllowance.length > 0
    ) {
      const jsonModel = JSON.stringify({
        id: new Date().getTime(),
        model,
        date: new Date().getTime() / 1000,
        eTourCode: st.code,
      });
      localStorage.setItem(`eTourDraft-${st.code}`, jsonModel);
    }
  };
}

export default ComponentName;
